import MemoMessageTerminateREC1 from '../../../page/memoMessageTerminateProject/memoMessageTerminateREC1'
import MemoMessageTerminate from '../../../page/memoMessageTerminateProject/terminateProjectByAdmin/memoMessageTerminate'

import { OfficerType, OfficerViewType } from './officerType'
import useOfficer from './useOfficer'
import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import * as Constants from '../../../../../../constants/constants'
import SignREC2 from '../../../page/sign/signMemoMessage/signREC2'
import SignREC1 from '../../../page/sign/signMemoMessage/signREC1'
import SignRepresentREC2 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC2'
import SignRepresentREC1 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC1'
import TerminateProjectRequestForm from '../../../page/requestNewProject/terminateProjectByAdmin/terminateProjectByAdmin'
import ResultOfConsider from '../../../page/resultOfConsider/terminateProjectByAdmin/resultOfConsider'

const OfficerView: React.FC<OfficerViewType> = (props) => {
    const { callbackSaveComplete, projectMode, submittedType, initialData, isViewMode, formValueRef } = props
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const renderPage = () => {
        const tabID = appFolderAndTabStore?.tabSelected?.id
        const REC = manageProjectStore?.projectData?.irbType
        switch (REC) {
            case 1:
                switch (tabID) {
                    case Constants.menuTab.tab21.id:
                        return (
                            <TerminateProjectRequestForm
                                formMode={projectMode}
                                projectSubmittedTypeID={submittedType}
                                initialData={initialData}
                                isViewMode={isViewMode}
                                btnClose={isViewMode}
                                formValueRef={formValueRef}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab9.id:
                        // code block
                        return <SignREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        // code block
                        return <SignRepresentREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab11.id:
                        // code block <div> save REC1</div>
                        return (
                            <MemoMessageTerminate
                                projectData={manageProjectStore?.projectData}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab23.id:
                        return (
                            <>
                                <ResultOfConsider projectData={manageProjectStore?.projectData} />
                            </>
                        )
                    default:
                        return <></>
                }

            case 2:
                switch (tabID) {
                    case Constants.menuTab.tab21.id:
                        return (
                            <TerminateProjectRequestForm
                                formMode={projectMode}
                                projectSubmittedTypeID={submittedType}
                                initialData={initialData}
                                isViewMode={isViewMode}
                                btnClose={isViewMode}
                                formValueRef={formValueRef}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab9.id:
                        // code block
                        return <SignREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        // code block
                        return <SignRepresentREC2 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab11.id:
                        // code block <div> save REC2</div>
                        return (
                            <MemoMessageTerminate
                                projectData={manageProjectStore?.projectData}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )
                    case Constants.menuTab.tab23.id:
                        return (
                            <>
                                <ResultOfConsider projectData={manageProjectStore?.projectData} />
                            </>
                        )
                    default:
                        return <div></div>
                }

            default:
                return <div></div>
        }
    }

    return <> {renderPage()} </>
}

const Officer: React.FC<OfficerType> = (props) => {
    const officer = useOfficer(props)
    return <OfficerView {...props} {...officer} />
}
export default Officer
